import Vue from 'vue'
import app from './index'
import money from './money'

// url 过滤器
Vue.filter('url', function (value) {
  return app.url(value)
})

// 金额格式化
Vue.filter('money', function (value) {
  return money(value)
})